import React from 'react'
import { Draggable } from 'react-beautiful-dnd'
import { TextareaAutosize } from '@mui/base'
import { ArchProgram } from 'apis/entities/architecture.entity'
import { InlineEditButtons } from 'components/InlineEditControls'
import { nestingPadding } from 'utils/ArchUtil'

export interface ProgramRowProps {
  program: ArchProgram
  draggableIndex: number
  actionButtons: React.ReactNode
  children?: React.ReactNode
  style?: React.CSSProperties
  refEditTextareas: React.MutableRefObject<Map<string, HTMLTextAreaElement>>
  isReadOnly: boolean
  isAutoFocus: boolean
  onDoubleClick: () => void
  onBlur: () => void
  onKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void
  onKeyUp: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void
  onConfirmEdit: () => void
  onCancelEdit: () => void
  onAfterRender: () => void
}

export function ProgramRow({
  program,
  draggableIndex,
  actionButtons,
  children,
  style,
  refEditTextareas,
  isReadOnly,
  isAutoFocus,
  onDoubleClick,
  onBlur,
  onKeyDown,
  onKeyUp,
  onConfirmEdit,
  onCancelEdit,
  onAfterRender,
}: ProgramRowProps) {
  const result = (
    <React.Fragment>
      <Draggable draggableId={`program-${program.id}`} index={draggableIndex}>
        {(provided, snapshot) => (
          <li
            ref={provided.innerRef}
            {...provided.draggableProps}
            className="arch-program-list-item hover:bg-[#F3F3F5]"
            style={{
              ...provided.draggableProps.style,
              boxShadow: snapshot.isDragging
                ? '0px 16px 24px 0px rgba(13, 13, 13, 0.2)'
                : '',
              borderLeft: '1px solid #D9D9D9C2',
              borderRight: '1px solid #D9D9D9C2',
              ...style,
            }}
          >
            <div style={{ paddingLeft: nestingPadding(0) }}>
              <TextareaAutosize
                data-testid={`input-program-name-${program.id}`}
                ref={(el: HTMLTextAreaElement | null) => {
                  if (el)
                    refEditTextareas.current.set(`program-${program.id}`, el)
                  else refEditTextareas.current.delete(`program-${program.id}`)
                }}
                className={`w-full ${
                  isReadOnly ? 'arch-read-only' : 'arch-add-input'
                }`}
                placeholder="Type program name here"
                defaultValue={program.name}
                readOnly={isReadOnly}
                autoFocus={isAutoFocus}
                onFocus={(e) => {
                  const value = e.currentTarget.value
                  e.currentTarget.value = ''
                  e.currentTarget.value = value
                }}
                onDoubleClick={onDoubleClick}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                onKeyUp={onKeyUp}
              />
              {!isReadOnly && (
                <InlineEditButtons
                  onConfirm={onConfirmEdit}
                  onCancel={onCancelEdit}
                />
              )}
              <div className="flex justify-end">{actionButtons}</div>
            </div>
          </li>
        )}
      </Draggable>
      {children}
    </React.Fragment>
  )
  onAfterRender()
  return result
}
